import useMediaQuery from '../../hooks/useMediaQuery';

export const useTimelineHorizontalScroll = () => {
  return useMediaQuery(
    '(min-width: 768px) and (prefers-reduced-motion: no-preference)'
  );
};
